<div
  class="overflow-hidden rounded-lg border border-borders-light bg-white text-black dark:border-borders-darker dark:bg-black-dark-light dark:text-white"
>
  @if (compact) {
  <div class="flex items-center gap-1.5 p-1.5">
    @if (data?.work?.cover && !coverFailed) {
    <img
      [src]="imagesDomain + '/' + data!.work.cover"
      [alt]="data!.work.title"
      class="h-[80px] w-[54px] shrink-0 rounded-lg object-cover"
      loading="lazy"
      referrerpolicy="no-referrer"
      (error)="coverFailed = true"
    />
    } @else {
    <div
      class="flex h-[80px] w-[54px] shrink-0 items-center justify-center rounded-lg bg-primary p-0.5"
    >
      <img
        src="/assets/images/icons/gemster-logo-typo.svg"
        alt="Gemster"
        class="w-full"
      />
    </div>
    }
    <div class="min-w-0 text-left">
      <p class="!m-0 text-xs text-grey dark:text-borders-dark">Gemster</p>
      <p class="!m-0 font-base font-bold text-base leading-tight line-clamp-2">
        {{ workTitle }}
      </p>
      @if (data?.share; as share) {
      <p class="!mt-0.5 !mb-0 text-sm !leading-[16px] truncate">
        {{ "WORK_SHARE.SHARED_BY" | translate: {username: share.username} }}
      </p>
      } @if (data?.work; as work) {
      <p
        class="!mt-0.5 !mb-0 text-sm !leading-[16px] text-grey dark:text-borders-dark truncate"
      >
        {{ workTypeLabels[work.type] | translate }}@if (work.genres.length) { ·
        }@for (genre of work.genres.slice(0, 2); track genre; let last = $last)
        {
        {{ (getGenreTranslationKey(genre) | translate) + (last ? "" : ", ") }} }
      </p>
      }
    </div>
  </div>
  } @else {
  <div class="bg-primary">
    @if (imageUrl && !imageFailed) {
    <img
      [src]="imageUrl"
      [alt]="(data?.work?.title ?? title) + ' - Gemster'"
      class="aspect-[1200/630] w-full object-contain"
      loading="lazy"
      referrerpolicy="no-referrer"
      (error)="imageFailed = true"
    />
    } @else {
    <div class="flex aspect-[1200/630] items-center justify-center p-1.5">
      <img
        src="/assets/images/icons/gemster-logo-typo.svg"
        alt="Gemster"
        class="w-[88px]"
      />
    </div>
    }
  </div>
  <div class="min-w-0 p-1.5 text-left">
    <p class="!m-0 text-sm text-grey dark:text-borders-dark">Gemster</p>
    <p class="!mt-0.5 !mb-0 font-bold text-sm !leading-[16px] line-clamp-2">
      {{ title || data?.social?.title }}
    </p>
  </div>
  } @if (showDetails && data?.share; as share) { @if (share.details &&
  (share.details.rating !== undefined || share.details.progress ||
  share.details.message)) {
  <app-public-share-details
    class="block px-1.5 pb-1.5"
    [share]="share"
    [workType]="data?.work?.type"
    [compact]="true"
  />
  } }
</div>
